// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as _ from "lodash";
import * as React from "react";
import { FavoriteLauncherMenuItem } from "./FavoriteLauncherMenuItem";
import { FavoriteLauncherMenuList } from "./FavoriteLauncherMenuList";
import { FavoriteDomainDataProvider } from "./FavoriteDomainDataProvider";
import { jsx as _jsx } from "react/jsx-runtime";
export const FavoriteLauncherMenu = props => {
  const {
    domain
  } = props;
  const getFavoritesItems = React.useCallback(favoris => _.map(favoris, ({
    identifiant,
    libelle,
    adresse,
    ordre
  }) => /*#__PURE__*/_jsx(FavoriteLauncherMenuItem, {
    identifiant: identifiant,
    adresse: adresse,
    libelle: libelle,
    ordre: ordre
  }, identifiant)), []);
  const renderFavoritesProvider = React.useCallback(favoris => /*#__PURE__*/_jsx(FavoriteLauncherMenuList, {
    items: getFavoritesItems(favoris)
  }), [getFavoritesItems]);
  return React.useMemo(() => /*#__PURE__*/_jsx(FavoriteDomainDataProvider, {
    domain: domain,
    children: renderFavoritesProvider
  }), [domain, renderFavoritesProvider]);
};